import React from "react";
import {
  ClipboardDocumentIcon,
  BackspaceIcon,
} from "@heroicons/react/24/outline";
import CustomTitleTerms from "../termsAndConditions/customTitleTerms";
import CustomTermPoints from "../termsAndConditions/customTermPoints";
import CustomTextingCard from "../termsAndConditions/customCard";
import { useTranslation } from "react-i18next";

const PackagingShipmentContainer = () => {
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  return (
    <div
      className={`px-4 py-3 lg:px-0 lg:py-8 max-container ${
        isRTL ? "rtl" : "ltr"
      }`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div
        className={` ${
          isRTL ? "text-right" : "text-left"
        }  lg:mx-0  py-6 lg:py-10  flex flex-col gap-y-2`}
      >
        {/* Privacy Policy */}
        <CustomTitleTerms title={t("PackagingShipmentTitle1")} first={true} />
        <CustomTermPoints title={t("PackagingShipmentf1")} />
        <CustomTermPoints title={t("PackagingShipmentf2")} />
        <CustomTermPoints title={t("PackagingShipmentf3")} />
        <CustomTermPoints title={t("PackagingShipmentf4")} />

        {/* Consent for Personal Information Transfer */}

        <CustomTitleTerms title={t("PackagingShipmentTitle2")} />
        <CustomTermPoints title={t("PackagingShipments1")} />
        <CustomTermPoints title={t("PackagingShipments2")} />
        <CustomTermPoints title={t("PackagingShipments3")} />
        <CustomTermPoints title={t("PackagingShipments4")} />
        <CustomTermPoints title={t("PackagingShipments5")} />
        <CustomTermPoints title={t("PackagingShipments6")} />
        <CustomTermPoints title={t("PackagingShipments7")} />
      </div>
    </div>
  );
};

export default PackagingShipmentContainer;
